module.exports = __webpack_public_path__ + "static/media/6.54a4e4fb.jpg";